import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../../components/feature/Navbar';
import Footer from '../../../../components/feature/Footer';

export default function UygulamaKorumaPolitikalariPage() {
  const [copied, setCopied] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);

  const jsonContent = `{
  "displayName": "Corporate Android BYOD Protection Policy",
  "description": "Android App protection for personal devices",
  "periodOfflineBeforeAccessCheck": "PT12H",
  "periodOnlineBeforeAccessCheck": "PT30M",
  "allowedInboundDataTransferSources": "managedApps",
  "allowedOutboundDataTransferDestinations": "managedApps",
  "organizationalCredentialsRequired": false,
  "allowedOutboundClipboardSharingLevel": "managedAppsWithPasteIn",
  "dataBackupBlocked": true,
  "deviceComplianceRequired": true,
  "managedBrowserToOpenLinksRequired": true,
  "saveAsBlocked": true,
  "periodOfflineBeforeWipeIsEnforced": "P90D",
  "pinRequired": true,
  "maximumPinRetries": 5,
  "simplePinBlocked": true,
  "minimumPinLength": 6,
  "pinCharacterSet": "alphanumeric",
  "periodBeforePinReset": "P30D",
  "allowedDataStorageLocations": [
    "oneDriveForBusiness",
    "sharePoint"
  ],
  "contactSyncBlocked": true,
  "printBlocked": true,
  "fingerprintBlocked": false,
  "disableAppPinIfDevicePinIsSet": false,
  "minimumRequiredOsVersion": "11.0.0",
  "minimumWarningOsVersion": "13.0.0",
  "managedBrowser": "microsoftEdge",
  "maximumAllowedDeviceThreatLevel": "secured",
  "mobileThreatDefenseRemediationAction": "block",
  "blockDataIngestionIntoOrganizationDocuments": false,
  "allowedDataIngestionLocations": [
    "oneDriveForBusiness",
    "sharePoint",
    "camera"
  ],
  "appActionIfDeviceComplianceRequired": "block",
  "appActionIfMaximumPinRetriesExceeded": "block",
  "pinRequiredInsteadOfBiometricTimeout": "PT30M",
  "screenCaptureBlocked": true,
  "encryptAppData": true,
  "deployedAppCount": 0,
  "isAssigned": false
}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(jsonContent).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-4xl mx-auto">
          <Link 
            to="/intune" 
            className="inline-flex items-center text-sm text-gray-600 hover:text-orange-600 mb-6 transition-colors"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Intune'a Geri Dön
          </Link>
          
          <div className="mb-8">
            <span className="inline-block px-4 py-1 bg-orange-100 text-orange-700 rounded-full text-sm font-medium mb-4">
              Microsoft Intune
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Uygulama Koruma Politikaları ile Veri Güvenliği
            </h1>
            <div className="flex items-center text-gray-600 text-sm">
              <i className="ri-calendar-line mr-2"></i>
              <span>18 Ağustos 2025</span>
              <span className="mx-3">•</span>
              <i className="ri-time-line mr-2"></i>
              <span>10 dakika okuma</span>
            </div>
          </div>

          <img 
            src="https://public.readdy.ai/ai/img_res/bb9b8dc611343ced805b0f6cc9c7b5c4.jpg"
            alt="Uygulama Koruma Politikaları"
            className="w-full h-96 object-cover rounded-2xl mb-12"
          />
        </div>
      </section>

      {/* Article Content */}
      <article className="pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            
            {/* Introduction */}
            <div className="mb-12">
              <p className="text-xl text-gray-700 leading-relaxed mb-6">
                BYOD (Bring Your Own Device) çalışma modelinin yaygınlaşmasıyla birlikte, şirket verilerinin kişisel cihazlarda güvenliğini sağlamak kritik bir zorluk haline geldi. Intune Uygulama Koruma Politikaları (APP), cihazı yönetmeden sadece iş uygulamalarını ve verilerini koruma imkanı sunar.
              </p>
            </div>

            {/* MAM without Enrollment */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Kayıt Olmadan MAM (MAM-WE)</h2>
              
              <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 mb-8">
                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 bg-orange-600 text-white rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-shield-user-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">MAM-WE Nedir?</h3>
                    <p className="text-gray-700">
                      Mobile Application Management Without Enrollment, cihazı Intune'a kaydetmeden uygulama düzeyinde koruma sağlar. Kullanıcı gizliliği korunurken, şirket verileri güvende tutulur.
                    </p>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-xl p-4">
                    <h4 className="font-bold text-gray-900 mb-2 flex items-center">
                      <i className="ri-check-line text-orange-600 mr-2"></i>
                      Avantajlar
                    </h4>
                    <ul className="text-sm text-gray-700 space-y-1">
                      <li>• Kullanıcı gizliliği korunur</li>
                      <li>• Hızlı dağıtım</li>
                      <li>• Kullanıcı direnci düşük</li>
                      <li>• Kişisel veriler görünmez</li>
                    </ul>
                  </div>

                  <div className="bg-white rounded-xl p-4">
                    <h4 className="font-bold text-gray-900 mb-2 flex items-center">
                      <i className="ri-information-line text-amber-600 mr-2"></i>
                      Sınırlamalar
                    </h4>
                    <ul className="text-sm text-gray-700 space-y-1">
                      <li>• Cihaz ayarları yönetilemez</li>
                      <li>• Sadece desteklenen uygulamalar</li>
                      <li>• Conditional Access sınırlı</li>
                      <li>• Tam envanter yok</li>
                    </ul>
                  </div>
                </div>
              </div>

              <img 
                src="https://readdy.ai/api/search-image?query=BYOD%20mobile%20device%20management%20concept%20showing%20personal%20smartphone%20with%20business%20apps%20protected%20by%20security%20layer%20modern%20illustration%20purple%20teal%20colors%20clean%20background&width=1200&height=600&seq=mam-we-concept&orientation=landscape"
                alt="MAM-WE Konsepti"
                className="w-full h-80 object-cover rounded-xl"
              />
            </section>

            {/* Data Protection Features */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Veri Koruma Özellikleri</h2>
              
              <div className="space-y-6">
                <div className="border-l-4 border-orange-600 pl-6 py-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-file-shield-line text-orange-600 mr-3"></i>
                    Veri Şifreleme
                  </h3>
                  <p className="text-gray-700 mb-4">
                    Uygulama verileri cihazda şifrelenir. Entra ID kimlik bilgileri ile şifre çözme anahtarı korunur.
                  </p>
                  <div className="bg-gray-900 rounded-lg p-4 overflow-x-auto">
                    <pre className="text-sm text-gray-100">
{`# Şifreleme Ayarları
{
  "dataProtection": {
    "encryptAppData": true,
    "encryptionMethod": "AES256",
    "keyDerivation": "PBKDF2",
    "minimumPinLength": 6
  }
}`}
                    </pre>
                  </div>
                </div>

                <div className="border-l-4 border-amber-600 pl-6 py-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-scissors-cut-line text-amber-600 mr-3"></i>
                    Kopyala-Yapıştır Kısıtlamaları
                  </h3>
                  <p className="text-gray-700 mb-4">
                    İş uygulamaları arasında veri paylaşımına izin verirken, kişisel uygulamalara veri aktarımını engelleyin.
                  </p>
                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">İş uygulamaları arası</span>
                        <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">İzin Ver</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">İş → Kişisel uygulama</span>
                        <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm font-medium">Engelle</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">Kişisel → İş uygulaması</span>
                        <span className="px-3 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-medium">Yapıştır İzni</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border-l-4 border-red-600 pl-6 py-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-save-line text-red-600 mr-3"></i>
                    Farklı Kaydet Kısıtlamaları
                  </h3>
                  <p className="text-gray-700 mb-4">
                    İş belgelerinin kişisel bulut depolama alanlarına kaydedilmesini engelleyin.
                  </p>
                  <div className="bg-gray-900 rounded-lg p-4 overflow-x-auto">
                    <pre className="text-sm text-gray-100">
{`# Kaydetme Politikası
{
  "saveAs": {
    "allowedLocations": [
      "OneDrive for Business",
      "SharePoint Online"
    ],
    "blockedLocations": [
      "Local Storage",
      "Personal Cloud Storage",
      "SD Card"
    ],
    "allowPrint": false
  }
}`}
                    </pre>
                  </div>
                </div>

                <div className="border-l-4 border-amber-600 pl-6 py-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-delete-bin-line text-amber-600 mr-3"></i>
                    Seçici Silme
                  </h3>
                  <p className="text-gray-700 mb-4">
                    Çalışan ayrıldığında veya cihaz kaybolduğunda, sadece iş verilerini uzaktan silin. Kişisel veriler korunur.
                  </p>
                  <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg">
                    <p className="text-sm text-gray-700">
                      <strong>Önemli:</strong> Seçici silme işlemi geri alınamaz. Kullanıcı bir sonraki oturum açışında iş verilerine erişemez.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Conditional Launch */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Koşullu Başlatma</h2>
              
              <p className="text-gray-700 mb-6">
                Belirli koşullar sağlanmadığında uygulamanın başlatılmasını engelleyin veya kısıtlayın.
              </p>

              <div className="grid grid-cols-2 gap-6 mb-8">
                <div className="bg-blue-50 rounded-xl p-6 border border-blue-100">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-shield-check-line text-blue-600 mr-2"></i>
                    Cihaz Koşulları
                  </h4>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-0.5"></i>
                      <span>Minimum işletim sistemi sürümü</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-0.5"></i>
                      <span>Jailbreak/Root kontrolü</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-0.5"></i>
                      <span>Tehdit seviyesi limiti</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-green-50 rounded-xl p-6 border border-green-100">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-apps-line text-green-600 mr-2"></i>
                    Uygulama Koşulları
                  </h4>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-green-600 mr-2 mt-0.5"></i>
                      <span>Minimum uygulama sürümü</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-green-600 mr-2 mt-0.5"></i>
                      <span>Çevrimdışı kullanım süresi</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-green-600 mr-2 mt-0.5"></i>
                      <span>PIN/Biyometrik zorunluluğu</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-green-600 mr-2 mt-0.5"></i>
                      <span>Hesap kimlik doğrulama süresi</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Ön Gereksinimler */}
              <div className="bg-amber-50 border-l-4 border-amber-500 rounded-lg p-6 mb-6">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <i className="ri-information-line text-amber-600 text-2xl"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-3">Ön Gereksinimler</h4>
                    <p className="text-sm text-gray-700 mb-3">
                      Aşağıdaki yapılandırmayı uygulamadan önce şu adımları tamamlamanız gerekmektedir:
                    </p>
                    <ol className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <span className="font-semibold text-amber-600 mr-2">1.</span>
                        <span>Graph Explorer adresine gidin ve admin hesabınızla giriş yapın.</span>
                      </li>
                      <li className="flex items-start">
                        <span className="font-semibold text-amber-600 mr-2">2.</span>
                        <span>Gerekli izinleri (DeviceManagementApps.ReadWrite.All) onaylayın.</span>
                      </li>
                      <li className="flex items-start">
                        <span className="font-semibold text-amber-600 mr-2">3.</span>
                        <span>POST metodunu seçin ve endpoint URL olarak aşağıdakini yapıştırın. https://graph.microsoft.com/beta/deviceAppManagement/iosManagedAppProtection&nbsp;</span>
                      </li>
                      <li className="flex items-start">
                        <span className="font-semibold text-amber-600 mr-2">4.</span>
                        <span>Request body bölümüne aşağıdaki JSON yapılandırmasını kopyalayıp yapıştırın.</span>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8 mb-8">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-amber-500 text-white rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-code-s-slash-line text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-gray-900 mb-4">Graph API ile Politika Oluşturma</h4>
                    <p className="text-gray-700 mb-4">
                      Intune Admin Center yerine Microsoft Graph API kullanarak programatik olarak politika oluşturabilirsiniz.
                    </p>
                    <ol className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <span className="font-semibold text-amber-600 mr-2">1.</span>
                        <span>Graph Explorer'a gidin: <code className="bg-white px-2 py-0.5 rounded text-xs">https://developer.microsoft.com/graph/graph-explorer</code></span>
                      </li>
                      <li className="flex items-start">
                        <span className="font-semibold text-amber-600 mr-2">2.</span>
                        <span>POST metodunu seçin ve endpoint olarak <code className="bg-white px-2 py-0.5 rounded text-xs">/beta/deviceAppManagement/androidManagedAppProtections</code> girin.</span>
                      </li>
                      <li className="flex items-start">
                        <span className="font-semibold text-amber-600 mr-2">3.</span>
                        <span>Gerekli izinleri onaylayın: <code className="bg-white px-2 py-0.5 rounded text-xs">DeviceManagementApps.ReadWrite.All</code></span>
                      </li>
                      <li className="flex items-start">
                        <span className="font-semibold text-amber-600 mr-2">4.</span>
                        <span>Request body bölümüne aşağıdaki JSON yapılandırmasını kopyalayıp yapıştırın.</span>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-xl">
                <div className="flex items-start">
                  <i className="ri-information-line text-2xl text-amber-600 mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Not: JSON Yapılandırması</h4>
                    <p className="text-gray-700 text-sm">
                      Koşullu başlatma yapılandırması için Graph API dokümantasyonunu inceleyerek ihtiyacınıza uygun JSON yapısını oluşturabilirsiniz. Yukarıdaki adımları takip ederek Graph Explorer üzerinden test edebilirsiniz.
                    </p>
                  </div>
                </div>
              </div>

              {/* Başarılı Uygulama Bilgilendirmesi */}
              <div className="mt-8 bg-green-50 border-l-4 border-green-500 rounded-lg p-6">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-green-600 text-2xl"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-3">Başarılı Uygulama Sonrası</h4>
                    <p className="text-sm text-gray-700 mb-4">
                      JSON yapılandırmasını Graph Explorer üzerinden başarıyla gönderdiğinizde, Intune portalında <strong>Apps → App protection policies → Protection</strong> bölümünde oluşturduğunuz politikayı göreceksiniz. Politika varsayılan olarak herhangi bir gruba atanmamış şekilde oluşturulur.
                    </p>
                    <p className="text-sm text-gray-700 mb-6">
                      Politikayı oluşturduktan sonra, öncelikle küçük bir <strong>pilot gruba atama</strong> yapmanız önerilir. Pilot grupta test ettikten ve kullanıcı geri bildirimlerini değerlendirdikten sonra, politikayı tüm organizasyona yaygınlaştırabilirsiniz. Atama işlemi için politikaya tıklayın ve <strong>Assignments</strong> sekmesinden hedef grupları seçin.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-6 rounded-xl overflow-hidden border-2 border-gray-200">
                <img 
                  src="https://static.readdy.ai/image/f3543b778985655566d8e7a649090a0e/cbde5ea0799bb1cdee53f5eb059bbcf4.png"
                  alt="Intune Portal - Apps Protection politika görünümü"
                  className="w-full h-auto object-contain cursor-pointer hover:opacity-90 transition-opacity"
                  onClick={() => setImageOpen(true)}
                />
                <div className="bg-gray-50 px-4 py-3 border-t border-gray-200">
                  <p className="text-xs text-gray-500 flex items-center">
                    <i className="ri-image-line mr-1.5"></i>
                    Intune Portal → Apps → Protection sayfasında oluşturulan politikanın görünümü
                    <span className="ml-2 text-gray-400">• Büyütmek için tıklayın</span>
                  </p>
                </div>
              </div>

              {/* Lightbox Modal */}
              {imageOpen && (
                <div 
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm cursor-pointer"
                  onClick={() => setImageOpen(false)}
                >
                  <button
                    onClick={() => setImageOpen(false)}
                    className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
                  >
                    <i className="ri-close-line text-2xl"></i>
                  </button>
                  <img 
                    src="https://static.readdy.ai/image/f3543b778985655566d8e7a649090a0e/cbde5ea0799bb1cdee53f5eb059bbcf4.png"
                    alt="Intune Portal - Apps Protection politika görünümü"
                    className="max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              )}

            </section>

            {/* Supported Apps */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Desteklenen Uygulamalar</h2>
              
              <p className="text-gray-700 mb-6">
                APP politikaları, Intune SDK'sı entegre edilmiş uygulamalarda çalışır. Microsoft uygulamaları varsayılan olarak desteklenir.
              </p>

              <div className="grid md:grid-cols-3 gap-4 mb-8">
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 text-center">
                  <i className="ri-mail-line text-4xl text-blue-600 mb-3"></i>
                  <h4 className="font-bold text-gray-900 mb-1">Outlook</h4>
                  <p className="text-sm text-gray-600">E-posta ve Takvim</p>
                </div>

                <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6 text-center">
                  <i className="ri-file-excel-line text-4xl text-green-600 mb-3"></i>
                  <h4 className="font-bold text-gray-900 mb-1">Office Apps</h4>
                  <p className="text-sm text-gray-600">Word, Excel, PowerPoint</p>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6 text-center">
                  <i className="ri-team-line text-4xl text-purple-600 mb-3"></i>
                  <h4 className="font-bold text-gray-900 mb-1">Teams</h4>
                  <p className="text-sm text-gray-600">İşbirliği ve İletişim</p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-6 text-center">
                  <i className="ri-cloud-line text-4xl text-teal-600 mb-3"></i>
                  <h4 className="font-bold text-gray-900 mb-1">OneDrive</h4>
                  <p className="text-sm text-gray-600">Bulut Depolama</p>
                </div>

                <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-6 text-center">
                  <i className="ri-share-line text-4xl text-indigo-600 mb-3"></i>
                  <h4 className="font-bold text-gray-900 mb-1">SharePoint</h4>
                  <p className="text-sm text-gray-600">İçerik Yönetimi</p>
                </div>

                <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-xl p-6 text-center">
                  <i className="ri-edge-line text-4xl text-pink-600 mb-3"></i>
                  <h4 className="font-bold text-gray-900 mb-1">Edge</h4>
                  <p className="text-sm text-gray-600">Güvenli Tarayıcı</p>
                </div>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-xl">
                <div className="flex items-start">
                  <i className="ri-information-line text-2xl text-blue-600 mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Özel Uygulamalar</h4>
                    <p className="text-gray-700 text-sm mb-2">
                      Kendi geliştirdiğiniz uygulamalara da APP desteği ekleyebilirsiniz:
                    </p>
                    <ul className="text-sm text-gray-700 space-y-1">
                      <li>• iOS: Intune App SDK for iOS</li>
                      <li>• Android: Intune App SDK for Android</li>
                      <li>• Xamarin: Intune App SDK Xamarin Bindings</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Implementation Steps */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Uygulama Adımları</h2>
              
              <div className="space-y-6">
                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                      1
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">Politika Oluşturma</h3>
                      <p className="text-gray-700 text-sm mb-3">
                        Intune admin center → Apps → App protection policies → Create policy
                      </p>
                      <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-700">
                        Platform seçin (iOS/iPadOS veya Android) ve politika adı verin
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                      2
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">Uygulama Seçimi</h3>
                      <p className="text-gray-700 text-sm mb-3">
                        Politikanın uygulanacağı uygulamaları seçin
                      </p>
                      <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-700">
                        Tüm Microsoft uygulamaları veya belirli uygulamalar seçilebilir
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                      3
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">Veri Koruma Ayarları</h3>
                      <p className="text-gray-700 text-sm mb-3">
                        Kopyala-yapıştır, kaydetme, paylaşma kısıtlamalarını yapılandırın
                      </p>
                      <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-700">
                        Şifreleme, yedekleme ve veri aktarım kurallarını belirleyin
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                      4
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">Erişim Gereksinimleri</h3>
                      <p className="text-gray-700 text-sm mb-3">
                        PIN, biyometrik, kimlik doğrulama ayarlarını yapılandırın
                      </p>
                      <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-700">
                        Kullanıcı deneyimi ile güvenlik arasında denge kurun
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                      5
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">Koşullu Başlatma</h3>
                      <p className="text-gray-700 text-sm mb-3">
                        Cihaz ve uygulama koşullarını, uyumsuzluk eylemlerini tanımlayın
                      </p>
                      <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-700">
                        Minimum sürümler, tehdit seviyeleri ve offline süreleri belirleyin
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                      6
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">Atama</h3>
                      <p className="text-gray-700 text-sm mb-3">
                        Politikayı kullanıcı gruplarına atayın
                      </p>
                      <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-700">
                        Pilot grup ile başlayın, ardından tüm organizasyona yaygınlaştırın
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </section>

            {/* Best Practices */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">En İyi Uygulamalar</h2>
              
              <div className="space-y-4">
                <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                  <i className="ri-user-heart-line text-2xl text-orange-600 mr-4 mt-1"></i>
                  <div>
                    <strong className="text-gray-900 block mb-2">Kullanıcı Eğitimi</strong>
                    <p className="text-gray-700 text-sm">
                      APP politikalarının neden gerekli olduğunu açıklayın. Kullanıcılar kısıtlamaların amacını anladığında kabul oranı artar.
                    </p>
                  </div>
                </div>

                <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                  <i className="ri-test-tube-line text-2xl text-orange-600 mr-4 mt-1"></i>
                  <div>
                    <strong className="text-gray-900 block mb-2">Pilot Test</strong>
                    <p className="text-gray-700 text-sm">
                      Yeni politikaları küçük bir pilot grupta test edin. Kullanıcı geri bildirimlerini toplayın ve gerekli ayarlamaları yapın.
                    </p>
                  </div>
                </div>

                <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                  <i className="ri-balance-line text-2xl text-orange-600 mr-4 mt-1"></i>
                  <div>
                    <strong className="text-gray-900 block mb-2">Güvenlik-Kullanılabilirlik Dengesi</strong>
                    <p className="text-gray-700 text-sm">
                      Aşırı kısıtlayıcı politikalar kullanıcı verimliliğini düşürür. Makul güvenlik seviyesi ile kullanıcı deneyimini dengeleyin.
                    </p>
                  </div>
                </div>

                <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                  <i className="ri-line-chart-line text-2xl text-orange-600 mr-4 mt-1"></i>
                  <div>
                    <strong className="text-gray-900 block mb-2">Düzenli İzleme</strong>
                    <p className="text-gray-700 text-sm">
                      APP raporlarını düzenli inceleyin. Uyumsuz cihazları ve kullanıcı davranışlarını takip edin.
                    </p>
                  </div>
                </div>

                <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                  <i className="ri-refresh-line text-2xl text-orange-600 mr-4 mt-1"></i>
                  <div>
                    <strong className="text-gray-900 block mb-2">Politika Güncellemeleri</strong>
                    <p className="text-gray-700 text-sm">
                      Yeni tehditler ve iş gereksinimleri doğrultusunda politikaları düzenli olarak gözden geçirin ve güncelleyin.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Related Articles */}
            <section className="mt-16 pt-12 border-t-2 border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">İlgili Makaleler</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <Link 
                  to="/intune/modern-cihaz-yonetimi"
                  className="group bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-orange-600 transition-all"
                >
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                    Modern Cihaz Yönetimi
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    Intune ile endpoint güvenliği ve MDM/MAM farkları
                  </p>
                  <span className="text-orange-600 text-sm font-medium">
                    Devamını Oku <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </Link>

                <Link 
                  to="/intune/windows-autopilot"
                  className="group bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-orange-600 transition-all"
                >
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                    Windows Autopilot
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    Sıfır dokunuş cihaz dağıtımı ile IT yükünü azaltın
                  </p>
                  <span className="text-orange-600 text-sm font-medium">
                    Devamını Oku <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </Link>
              </div>
            </section>

          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}
